import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { createUserApi } from "@org-avp/avp-avengers-user-service-api";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../utils/header.utils";

const baseQueryArgs: Parameters<typeof fetchBaseQuery>[0] = {
  baseUrl: environment.NX_USER_SERVICE_BASE_URL,
  prepareHeaders,
};

export const userApi: ReturnType<typeof createUserApi> = createUserApi(baseQueryArgs);
